import { Box } from '@zoopla-eng/zds/box';
import { Link } from '@zoopla-eng/zds/link';
import { fontGroups } from '@zoopla-eng/zds/themes';
import { FC } from 'react';
import { containerStyle } from './DiscoverMore.styles.css';

const MAIN_SITE_LINK = 'https://www.zoopla.co.uk';

type Props = {
    searchArea: string | null;
    housePricesUri: string | null;
    findAgentsUri: string | null;
};

export const DiscoverMore: FC<React.PropsWithChildren<Props>> = ({
    searchArea,
    housePricesUri,
    findAgentsUri
}) => {
    return searchArea && housePricesUri && findAgentsUri ? (
        <div className={containerStyle}>
            <Box pt="M100" pb="S200">
                <h3 className={fontGroups.whisk}>
                    Discover more property information on Zoopla.
                </h3>
            </Box>
            <p>
                Explore{' '}
                <Link
                    key="prices"
                    href={`${MAIN_SITE_LINK}${housePricesUri}`}
                    data-testid="house-prices-link"
                >
                    house prices in {searchArea}
                </Link>{' '}
                and{' '}
                <Link
                    key="agents"
                    href={`${MAIN_SITE_LINK}${findAgentsUri}`}
                    data-testid="find-agents-link"
                >
                    find {searchArea} agents
                </Link>
            </p>
        </div>
    ) : null;
};
